import { Action, ActionList } from "./combineReducers";

type Dispatcher = (dispatch: <A extends Action | ActionList>(commit: A) => void) => void | Promise<void>;
type Actions = Record<string, (...args: any[]) => Action | ActionList | Dispatcher>;

export const createActions = <A extends Actions>(actions: A) => Object.freeze(actions);
